import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
//import icon
import { IoMdAdd, IoMdClose, IoMdRemove } from 'react-icons/io';

//import cart context
import { CartContext } from '../contexts/CartContext';

const CartItem = ({ item }) => {
  const { removeFromCart, increaseAmount, decreaseAmount } = useContext(CartContext);
  //destructure item
  const { id, title, image, price, amount } = item; 
  return (
    <div className='flex gap-x-4 py-2 lg:px-6 border-b border-gray-200 w-full font-light text-gray-500'>
      <div className='w-full min-h-[150px] flex items-center gap-x-4'>
        <div>
          
       </div>
        {/*image*/}
        
        <div>
          <Link to={`/product/${id}`}>
            <img className='max-w-[80px]' src={image} alt="" />          
          </Link>
        </div>
        <div className='flex w-full flex-col'>
          <div className='flex justify-between mb-2'>
            <Link to={`/product${id}`}>
              <div className='text-sm uppercase font-medium max-w-[240px] text-primary hover:underline'>{title}</div>
            </Link>
            {/*remove icon */}
            <div  className='text-xl cursor-pointer' >
              <IoMdClose onClick={() => removeFromCart(id)} className='text-gray-500 hover:text-red-500 transition' />
            </div>
          </div>
          <div className=' flex gap-x-2 h-[36px]'>
            <div className='flex font-medium flex-1 max-w-[100px]  items-centerh-full border text-primary'>
              <div onClick={() =>decreaseAmount(id)} className='flex-1 flex justify-center items-center cursor-pointer h-full '>
                <IoMdRemove  />
              </div>
              {/*amount*/}
              <div className='h-full flex justify-center items-center px-2'>{amount}</div>
              {/*add icon */}
              <div onClick={()=>increaseAmount(id)} className='flex-1 h-full flex justify-center items-center cursor-pointer'>
                <IoMdAdd />
              </div>
            </div>
            {/*minus icon*/}
           
            {/*qty*/}
            <div>qty</div>
            {/*item price */}
            <div className='flex-1 flex items-center justify-around'>$ {price}</div>
            {/*final price*/}
            {/* make the price at 2 decimals */}
            <div className='flex-1 flex justify-end items-center text-primary font-medium'>{`${parseFloat(price * amount).toFixed(2)}`} </div>

          </div>
        </div>
       
        {/*qty*/}
       
       
      </div>
    
  </div>
)
};

export default CartItem;
